
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PrizeDetailsSectionProps {
  formValues: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  handleRewardChange: (value: string) => void;
  rewards: any[];
}

const PrizeDetailsSection: React.FC<PrizeDetailsSectionProps> = ({
  formValues,
  handleInputChange,
  handleRewardChange,
  rewards
}) => {
  const { t } = useTranslationUtils();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">{t('admin.prizeDetails', 'Prize Details')}</h3>
      
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="prize_points">{t('admin.pointsPrize', 'Points Prize')}</Label>
          <Input
            id="prize_points"
            name="prize_points"
            type="number"
            min="0"
            value={formValues.prize_details.points}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="prize_reward_id">{t('admin.rewardPrize', 'Reward Prize')}</Label>
          <Select 
            value={formValues.prize_details.reward_id || "none"}
            onValueChange={handleRewardChange}
          >
            <SelectTrigger id="prize_reward_id">
              <SelectValue placeholder={t('admin.selectReward', 'Select reward')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="none">{t('admin.noReward', 'No reward')}</SelectItem>
              {rewards.map(reward => (
                <SelectItem key={reward.id} value={reward.id}>
                  {reward.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="prize_description">{t('admin.prizeDescription', 'Prize Description')}</Label>
        <Textarea
          id="prize_description"
          name="prize_description"
          placeholder={t('admin.enterPrizeDetails', 'Enter prize details')}
          value={formValues.prize_details.description}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default PrizeDetailsSection;
